// FFs
export const FEEDBACK_PAGE_FF = 'learning_app_fe_feedback_page';
export const CHAMPIONS_PAGE_FF = 'community-champions-page';
export const CONTENT_ISSUE_BANNER_FF = 'content-issue-banner';
export const EMAIL_SUBSCRIPTION_FF = 'learning_app_fe_email_subscription';
export const GEO_TARGETED_LINK_FF = 'learning_app_fe_geo-targeted_link';
export const COMMUNITY_ACCOUNT_SWITCHER_FF = 'community-account-switcher';
export const NEW_LEARNING_PATH_PAGE_FF = 'learning_app_fe_new_learning_path_page';
export const NEW_COURSE_PAGE_FF = 'learning_app_fe_new_course_page';
export const NEW_TOP_NAVIGATION_FF = 'community_new_top_navigation';
export const CONTENT_VERSIONING_FF = 'content_versioning';
export const ALM_INTEGRATION_FF = 'learning-alm-enabled';
export const ATLENZ_FF = 'atlenz_learning';
export const ROVO_HUB_FF = 'learning_app_fe-rovo_hub_enabled';

export enum Environment {
  'DEVELOPMENT' = 'development',
  'STAGING' = 'staging',
  'PRODUCTION' = 'production',
  'LOCAL' = 'local',
}

//Hubs type
export enum AlternativeContentHubType {
  CERT_PREP = 'cert-prep',
  ROLE_BASED = 'role-based',
}

export enum AlternativeCollectionType {
  ROLE_BASED = 'role-based',
  CERT_PREP = 'cert-prep',
}

export enum LandingType {
  LIVE_TRAINING = 'live-training',
  CERTIFICATION_DETAIL = 'certification-detail',
}

export enum ContentHubType {
  CERT_PREP = 'prepare-for-a-certification',
  ROLE_BASED = 'grow-your-career',
  LEARNING_PATHS = 'all-learning-paths',
  CERTIFICATIONS = 'certifications',
  RESOURCES_AND_SUPPORT = 'resources-and-support',
  ROVO = 'rovo',
}

export enum CollectionType {
  CERT_PREP = 'certification-prep',
  ROLE_BASED = 'career',
  TOPIC = 'topic',
}

export enum ResourceType {
  SmLesson = 'lesson',
  SmCourse = 'course',
  LearningPath = 'learningPath',
  Collection = 'collection',
  Certification = 'certification',
  InstructorLedTraining = 'instructorLedTraining',
}
